/* VUKAR COD Form — free replacement for Releasit COD Form
 * Two paths from one form:
 *   Cash on Delivery -> order created directly by our endpoint (no checkout page)
 *   Pay online       -> Shopify checkout, fully pre-filled
 * v2.0
 */
(function () {
  'use strict';

  var CFG = window.VCOD_CONFIG || {};
  var ENDPOINT   = CFG.endpoint || 'https://codform.submersibleshop.com/cod/order.php';
  var BTN_TEXT   = CFG.buttonText || 'Order Now - Cash on Delivery';
  var TITLE      = CFG.title || 'CASH ON DELIVERY';
  var COD_TEXT   = CFG.codText || 'PLACE ORDER - Cash on Delivery';
  var PRE_TEXT   = CFG.prepaidText || 'Pay online';
  var NOTE_HTML  = CFG.noteHtml || '';

  var STATES = ['Andaman and Nicobar Islands','Andhra Pradesh','Arunachal Pradesh','Assam','Bihar',
    'Chandigarh','Chhattisgarh','Dadra and Nagar Haveli and Daman and Diu','Delhi','Goa','Gujarat',
    'Haryana','Himachal Pradesh','Jammu and Kashmir','Jharkhand','Karnataka','Kerala','Ladakh',
    'Lakshadweep','Madhya Pradesh','Maharashtra','Manipur','Meghalaya','Mizoram','Nagaland','Odisha',
    'Puducherry','Punjab','Rajasthan','Sikkim','Tamil Nadu','Telangana','Tripura','Uttar Pradesh',
    'Uttarakhand','West Bengal'];

  /* pincode first: it auto-fills city + state, so 5 typed fields instead of 8 */
  var FIELDS = [
    { k:'zip',       label:'Pincode',       ph:'6-digit pincode',               half:true,  type:'tel', maxlength:6,  mode:'numeric' },
    { k:'phone',     label:'Mobile number', ph:'10-digit mobile number',        half:true,  type:'tel', maxlength:10, mode:'numeric' },
    { k:'full_name', label:'Full name',     ph:'Your full name',                half:false },
    { k:'address1',  label:'Address',       ph:'House / street / village',      half:false },
    { k:'address2',  label:'Landmark',      ph:'Nearby school, hospital, shop', half:false }
  ];

  var product=null, variantId=null, qty=1, overlay=null, busy=false;
  var codAllowed=true, codMessage='', prepaidDiscount=(CFG.prepaidDiscount==null?3:(CFG.prepaidDiscount|0)), prepaidDiscountMinimum=100, checkedPin='';

  /* ---------- small helpers ---------- */
  function qs(s,r){ return (r||document).querySelector(s); }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function money(p){ return 'Rs. ' + (Number(p)/100).toLocaleString('en-IN',
    {minimumFractionDigits:2, maximumFractionDigits:2}); }
  function track(n,p){ p=p||{}; p.source='vukar_cod_form';
    try{ window.dataLayer=window.dataLayer||[]; window.dataLayer.push(Object.assign({event:n},p)); }catch(e){}
    try{ if(typeof window.gtag==='function') window.gtag('event',n,p); }catch(e){}
    try{ if(typeof window.fbq==='function') window.fbq('trackCustom',n,p); }catch(e){}
  }
  function val(k){ var e=qs('#vcod-'+k); return e ? String(e.value||'').trim() : ''; }

  /* ---------- product ---------- */
  function productForm(){ return qs('form[action*="/cart/add"]'); }
  function readVariant(){ var f=productForm(); if(!f) return null;
    var e=f.querySelector('[name="id"]'); return e?String(e.value):null; }
  function readQty(){ var f=productForm(); if(!f) return 1;
    var e=f.querySelector('[name="quantity"]'); var n=e?parseInt(e.value,10):1;
    return (!n||n<1)?1:n; }
  function loadProduct(){
    if(product) return Promise.resolve(product);
    var h=(location.pathname.match(/\/products\/([^/?#]+)/)||[])[1];
    if(!h) return Promise.reject(new Error('not a product page'));
    return fetch('/products/'+h+'.js',{credentials:'same-origin'})
      .then(function(r){return r.json();}).then(function(p){ product=p; return p; });
  }
  function currentVariant(){
    if(!product) return null;
    var id=variantId||readVariant(), v=null;
    product.variants.forEach(function(x){ if(String(x.id)===String(id)) v=x; });
    return v||product.variants[0];
  }

  /* ---------- pincode -> city/state, then ask the server about COD ---------- */
  var pinCache={};
  function lookupPin(pin){
    if(!/^\d{6}$/.test(pin)) return;
    if(pinCache[pin]){ applyPin(pinCache[pin]); checkCod(); return; }
    var ctl=new AbortController();
    var t=setTimeout(function(){ ctl.abort(); },2500);
    fetch('https://api.postalpincode.in/pincode/'+pin,{signal:ctl.signal})
      .then(function(r){return r.json();})
      .then(function(j){
        clearTimeout(t);
        var list=(j&&j[0]&&j[0].PostOffice)||[];
        var o=null;
        list.forEach(function(x){ if(!o&&x.DeliveryStatus==='Delivery') o=x; });
        o=o||list[0];
        if(!o) return;
        var got={city:o.District||'', state:o.State||''};
        pinCache[pin]=got; applyPin(got);
      })
      .catch(function(){ clearTimeout(t); })
      .then(function(){ checkCod(); });
  }
  function applyPin(got){
    var c=qs('#vcod-city'), p=qs('#vcod-province');
    if(c&&got.city){ c.value=got.city; clearErr(c); }
    if(p&&got.state){
      var m=null, want=String(got.state).toLowerCase().replace(/[^a-z]/g,'');
      STATES.forEach(function(s){ if(s.toLowerCase().replace(/[^a-z]/g,'')===want) m=s; });
      p.value=m||''; if(m) clearErr(p);
    }
    showAuto(true);
  }
  function showAuto(on){
    var b=qs('.vcod-auto'); if(!b) return;
    b.classList.toggle('vcod-auto-on', !!on);
    var t=qs('.vcod-auto-txt');
    if(t) t.textContent=[val('city'), val('province')].filter(Boolean).join(', ');
  }
  function unlockAuto(){ var b=qs('.vcod-auto'); if(b) b.classList.add('vcod-auto-edit');
    var c=qs('#vcod-city'); if(c) c.focus(); }

  /* ask the server whether this area may use COD */
  function checkCod(){
    var zip=val('zip');
    if(!ENDPOINT || !/^\d{6}$/.test(zip)) return;
    if(zip===checkedPin) return;
    checkedPin=zip;
    fetch(ENDPOINT,{
      method:'POST', headers:{'Content-Type':'application/json'},
      body:JSON.stringify({action:'check', zip:zip, province:val('province'), city:val('city')})
    })
    .then(function(r){return r.json();})
    .then(function(j){
      if(!j) return;
      codAllowed = j.cod !== false;
      codMessage = j.message || '';
      if(typeof j.prepaidDiscount==='number') prepaidDiscount=j.prepaidDiscount;
      if(typeof j.prepaidDiscountMinimum==='number') prepaidDiscountMinimum=j.prepaidDiscountMinimum;
      if(!codAllowed) track('vcod_cod_blocked',{pincode:zip, reason:j.reason||''});
      refreshActions();
    })
    .catch(function(){ /* server unreachable - leave COD on, the server checks again on submit */ });
  }

  /* ---------- validation ---------- */
  function setErr(el,msg){ el.classList.add('vcod-bad');
    var w=el.closest('.vcod-f'); if(!w) return;
    var e=w.querySelector('.vcod-err');
    if(!e){ e=document.createElement('div'); e.className='vcod-err'; w.appendChild(e); }
    e.textContent=msg; }
  function clearErr(el){ el.classList.remove('vcod-bad');
    var w=el.closest('.vcod-f'); if(!w) return;
    var e=w.querySelector('.vcod-err'); if(e) e.textContent=''; }

  function validate(){
    var ok=true, first=null;
    var checks=[
      {k:'zip',       label:'Pincode',      re:/^\d{6}$/,      msg:'Enter a valid 6-digit pincode'},
      {k:'phone',     label:'Mobile number',re:/^[6-9]\d{9}$/, msg:'Enter a valid 10-digit mobile number'},
      {k:'full_name', label:'Full name',    min:3,             msg:'Please enter your full name'},
      {k:'address1',  label:'Address',      min:5,             msg:'Please enter your full address'},
      {k:'address2',  label:'Landmark',     min:3,             msg:'Please enter a nearby landmark'},
      {k:'city',      label:'City',         min:2,             msg:'City is required'},
      {k:'province',  label:'State',        min:2,             msg:'State is required'}
    ];
    checks.forEach(function(c){
      var el=qs('#vcod-'+c.k); if(!el) return;
      var v=String(el.value||'').trim(), m='';
      if(!v) m=c.label+' is required';
      else if(c.re && !c.re.test(v)) m=c.msg;
      else if(c.min && v.length<c.min) m=c.msg;
      if(m){ setErr(el,m); ok=false; if(!first) first=el; } else clearErr(el);
    });
    if(!ok && (!val('city')||!val('province'))) unlockAuto();
    if(first){ first.focus(); first.scrollIntoView({block:'center',behavior:'smooth'}); }
    return ok;
  }

  function splitName(f){
    var p=String(f||'').trim().split(/\s+/);
    return p.length===1 ? {first:p[0], last:p[0]} : {first:p[0], last:p.slice(1).join(' ')};
  }

  /* ---------- prepaid: pre-filled Shopify checkout ---------- */
  function checkoutUrl(){
    var v=currentVariant(), p=new URLSearchParams();
    function put(k,x){ if(x) p.append(k,x); }
    var nm=splitName(val('full_name')), phone='+91'+val('phone');
    put('checkout[shipping_address][first_name]', nm.first);
    put('checkout[shipping_address][last_name]',  nm.last);
    put('checkout[shipping_address][address1]',   val('address1'));
    put('checkout[shipping_address][address2]',   val('address2'));
    put('checkout[shipping_address][city]',       val('city'));
    put('checkout[shipping_address][province]',   val('province'));
    put('checkout[shipping_address][zip]',        val('zip'));
    put('checkout[shipping_address][phone]',      phone);
    put('checkout[shipping_address][country]',    'India');
    put('checkout[phone]', phone);   /* without +91 Shopify assumes +1 (US) */
    put('attributes[Order source]', 'VUKAR COD form - prepaid');
    put('attributes[Landmark]', val('address2'));
    var us=new URLSearchParams(location.search);
    ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].forEach(function(k){
      if(us.get(k)) put('attributes['+k+']', us.get(k));
    });
    return '/cart/'+v.id+':'+qty+'?'+p.toString();
  }

  /* ---------- markup ---------- */
  function fieldHtml(f){
    var id='vcod-'+f.k;
    return '<div class="vcod-f'+(f.half?' vcod-half':'')+'">'+
      '<label class="vcod-lb" for="'+id+'">'+esc(f.label)+'<span class="vcod-req">*</span></label>'+
      '<input id="'+id+'" class="vcod-in" type="'+(f.type||'text')+'"'+
      (f.mode?' inputmode="'+f.mode+'"':'')+(f.maxlength?' maxlength="'+f.maxlength+'"':'')+
      ' placeholder="'+esc(f.ph)+'" autocomplete="off"></div>';
  }
  function autoHtml(){
    return '<div class="vcod-auto">'+
      '<div class="vcod-auto-shown"><span class="vcod-tick">&#10003;</span>'+
        '<span class="vcod-auto-txt"></span>'+
        '<button type="button" class="vcod-edit" data-act="editauto">Change</button></div>'+
      '<div class="vcod-auto-inputs">'+
        '<div class="vcod-f vcod-half"><label class="vcod-lb" for="vcod-city">City<span class="vcod-req">*</span></label>'+
          '<input id="vcod-city" class="vcod-in" type="text" placeholder="City" autocomplete="off"></div>'+
        '<div class="vcod-f vcod-half"><label class="vcod-lb" for="vcod-province">State<span class="vcod-req">*</span></label>'+
          '<select id="vcod-province" class="vcod-in"><option value="">State</option>'+
          STATES.map(function(s){return '<option value="'+esc(s)+'">'+esc(s)+'</option>';}).join('')+
          '</select></div>'+
      '</div></div>';
  }

  function actionsHtml(){
    var v=currentVariant(), line=v.price*qty;
    var h='';
    if(!codAllowed){
      h+='<div class="vcod-blocked">'+esc(codMessage||
        'Cash on Delivery is not available for your area. You can still order by paying online.')+'</div>';
    }
    if(codAllowed && ENDPOINT){
      h+='<button type="button" class="vcod-submit" data-act="cod">'+esc(COD_TEXT)+
         ' &middot; '+money(line)+'</button>';
    }
    var saving=Math.min(line,Math.max(Math.round(line*prepaidDiscount/100),prepaidDiscountMinimum*100));
    var save = saving>0 ? (' &amp; save '+money(saving)) : '';
    h+='<button type="button" class="vcod-submit vcod-alt'+((codAllowed&&ENDPOINT)?'':' vcod-primary')+
       '" data-act="prepaid">'+esc(PRE_TEXT)+save+'</button>';
    h+='<div class="vcod-secure">&#128274; Your details are safe. Free delivery.</div>';
    return h;
  }

  function summaryHtml(){
    var v=currentVariant(), line=v.price*qty;
    var img=(product.featured_image||(product.images&&product.images[0])||'');
    var showOpt=v.title && v.title!=='Default Title';
    return '<div class="vcod-card">'+
        (img?'<img class="vcod-img" src="'+esc(img)+'" alt="" loading="lazy">':'')+
        '<div class="vcod-cbody">'+
          '<div class="vcod-ptitle">'+esc(product.title)+'</div>'+
          (showOpt?'<div class="vcod-popt">'+esc(v.title)+'</div>':'')+
          '<div class="vcod-pprice">'+money(v.price)+'</div>'+
          '<div class="vcod-qty">'+
            '<button type="button" class="vcod-q" data-q="-1" aria-label="Decrease">&minus;</button>'+
            '<span class="vcod-qn">'+qty+'</span>'+
            '<button type="button" class="vcod-q" data-q="1" aria-label="Increase">+</button>'+
          '</div></div></div>'+
      '<div class="vcod-tot">'+
        '<div class="vcod-row"><span>Subtotal</span><span>'+money(line)+'</span></div>'+
        '<div class="vcod-row"><span>Shipping</span><span class="vcod-free">Free</span></div>'+
        '<div class="vcod-row vcod-grand"><span>Total</span><span>'+money(line)+'</span></div>'+
      '</div><div class="vcod-actions">'+actionsHtml()+'</div>';
  }

  function render(){
    qs('.vcod-body',overlay).innerHTML=
      '<div class="vcod-grid">'+
        '<div class="vcod-left">'+
          '<h3 class="vcod-h3">Where should we deliver?</h3>'+
          '<div class="vcod-fields">'+
            fieldHtml(FIELDS[0])+fieldHtml(FIELDS[1])+autoHtml()+
            FIELDS.slice(2).map(fieldHtml).join('')+
            '<input type="text" name="company" id="vcod-company" class="vcod-hp" tabindex="-1" autocomplete="off">'+
          '</div>'+
          (NOTE_HTML?'<div class="vcod-note">'+NOTE_HTML+'</div>':'')+
        '</div>'+
        '<div class="vcod-right">'+summaryHtml()+'</div>'+
      '</div>';
  }
  function refreshSummary(){ var r=qs('.vcod-right',overlay); if(r) r.innerHTML=summaryHtml(); }
  function refreshActions(){ var a=qs('.vcod-actions',overlay); if(a) a.innerHTML=actionsHtml(); }

  function renderThankYou(d){
    qs('.vcod-body',overlay).innerHTML=
      '<div class="vcod-done">'+
        '<div class="vcod-done-tick">&#10003;</div>'+
        '<h3 class="vcod-done-h">Order placed</h3>'+
        '<div class="vcod-done-no">'+esc(d.orderName||'')+'</div>'+
        '<p class="vcod-done-p">'+esc(d.productTitle||'')+'<br><strong>Rs. '+esc(d.total||'')+
          '</strong> &middot; Cash on Delivery</p>'+
        '<p class="vcod-done-p">Delivering to<br>'+esc(val('full_name'))+', '+esc(val('address1'))+
          ', '+esc(val('city'))+' '+esc(val('zip'))+'<br>'+esc('+91 '+val('phone'))+'</p>'+
        '<p class="vcod-done-note">Our team will call you shortly to confirm.</p>'+
        '<button type="button" class="vcod-submit" data-act="close">Done</button>'+
      '</div>';
  }

  function ensureOverlay(){
    if(overlay) return overlay;
    overlay=document.createElement('div');
    overlay.className='vcod-overlay'; overlay.setAttribute('aria-hidden','true');
    overlay.innerHTML='<div class="vcod-modal" role="dialog" aria-modal="true" aria-label="'+esc(TITLE)+'">'+
      '<div class="vcod-head"><span class="vcod-ico">&#127968;</span>'+
      '<span class="vcod-title">'+esc(TITLE)+'</span>'+
      '<button type="button" class="vcod-x" aria-label="Close">&times;</button></div>'+
      '<div class="vcod-body"></div></div>';
    document.body.appendChild(overlay);
    return overlay;
  }

  function open(){
    loadProduct().then(function(){
      variantId=readVariant(); qty=readQty();
      codAllowed=true; codMessage=''; checkedPin='';
      ensureOverlay(); render();
      overlay.classList.add('vcod-on'); overlay.setAttribute('aria-hidden','false');
      document.body.style.overflow='hidden';
      var v=currentVariant();
      track('vcod_open',{item_id:v?(v.sku||v.id):'', value:v?v.price/100:0});
      var f=qs('#vcod-zip'); if(f&&window.innerWidth>749) f.focus();
    }).catch(function(){ var f=productForm(); if(f) f.submit(); });
  }
  function close(){
    if(!overlay) return;
    overlay.classList.remove('vcod-on'); overlay.setAttribute('aria-hidden','true');
    document.body.style.overflow='';
  }

  function setBusy(on,label){
    busy=on;
    var b=qs('.vcod-actions .vcod-submit',overlay);
    if(b){ b.disabled=on; if(on) b.textContent=label||'Please wait…'; }
    if(!on) refreshActions();
  }
  function showError(msg,field){
    var box=qs('.vcod-actions',overlay); if(!box) return;
    var e=qs('.vcod-fail',overlay);
    if(!e){ e=document.createElement('div'); e.className='vcod-fail'; box.insertBefore(e,box.firstChild); }
    e.textContent=msg;
    if(field){ var el=qs('#vcod-'+field); if(el){ setErr(el,msg); el.focus(); } }
  }

  function submitPrepaid(){
    if(busy||!validate()) return;
    if(!ENDPOINT){ window.location.href=checkoutUrl(); return; }
    var v=currentVariant();
    var us=new URLSearchParams(location.search), attrs={};
    ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].forEach(function(k){
      if(us.get(k)) attrs[k]=us.get(k);
    });
    track('vcod_prepaid',{item_id:v?(v.sku||v.id):'', quantity:qty,
      value:v?(v.price*qty)/100:0, currency:'INR'});
    setBusy(true,'Creating secure checkout…');
    fetch(ENDPOINT,{
      method:'POST', headers:{'Content-Type':'application/json'},
      body:JSON.stringify({action:'prepaid', variantId:String(v.id), quantity:qty,
        full_name:val('full_name'), phone:val('phone'), zip:val('zip'),
        address1:val('address1'), address2:val('address2'), city:val('city'),
        province:val('province'), company:val('company'), attrs:attrs})
    })
    .then(function(r){return r.json().then(function(j){return {status:r.status,body:j};});})
    .then(function(res){
      var j=res.body||{};
      if(j.ok&&j.checkoutUrl){
        track('vcod_prepaid_checkout',{value:parseFloat(j.total||'0'),
          discount:parseFloat(j.discount||'0'),currency:'INR'});
        window.location.href=j.checkoutUrl;
        return;
      }
      setBusy(false);
      showError(j.message||'Could not open secure checkout. Please try again.',j.field||'');
      track('vcod_prepaid_failed',{reason:j.error||('http_'+res.status)});
    })
    .catch(function(){
      setBusy(false);
      showError('Network problem. Please check your connection and try again.');
      track('vcod_prepaid_failed',{reason:'network'});
    });
  }

  function submitCOD(){
    if(busy||!validate()) return;
    if(!ENDPOINT){ submitPrepaid(); return; }
    var v=currentVariant();
    track('vcod_submit',{item_id:v?(v.sku||v.id):'', quantity:qty,
      value:v?(v.price*qty)/100:0, currency:'INR'});
    setBusy(true,'Placing your order…');

    var us=new URLSearchParams(location.search), attrs={};
    ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].forEach(function(k){
      if(us.get(k)) attrs[k]=us.get(k);
    });

    fetch(ENDPOINT,{
      method:'POST', headers:{'Content-Type':'application/json'},
      body:JSON.stringify({
        action:'create', variantId:String(v.id), quantity:qty,
        full_name:val('full_name'), phone:val('phone'), zip:val('zip'),
        address1:val('address1'), address2:val('address2'),
        city:val('city'), province:val('province'),
        company:val('company'), attrs:attrs
      })
    })
    .then(function(r){ return r.json().then(function(j){ return {status:r.status, body:j}; }); })
    .then(function(res){
      var j=res.body||{};
      if(j.ok && j.orderName){
        track('vcod_order_placed',{order_name:j.orderName, value:parseFloat(j.total||'0'), currency:'INR'});
        renderThankYou(j);
        return;
      }
      setBusy(false);
      if(j.error==='cod_blocked'){ codAllowed=false; codMessage=j.message||''; refreshActions(); return; }
      showError(j.message||'Could not place the order. Please try again or call us.', j.field||'');
      track('vcod_order_failed',{reason:j.error||('http_'+res.status)});
    })
    .catch(function(){
      setBusy(false);
      showError('Network problem. Please check your connection and try again.');
      track('vcod_order_failed',{reason:'network'});
    });
  }

  /* ---------- button on the product page ---------- */
  function injectButton(){
    if(!/\/products\//.test(location.pathname)) return;
    if(qs('.vcod-open-btn')) return;
    var f=productForm(); if(!f) return;
    var host=f.querySelector('.product-form__buttons')||f;
    var b=document.createElement('button');
    b.type='button'; b.className='vcod-open-btn'; b.setAttribute('data-vcod-open','');
    b.innerHTML='<span class="vcod-cart">&#128722;</span><span>'+esc(BTN_TEXT)+'</span>';
    host.appendChild(b);
  }

  /* ---------- events ---------- */
  document.addEventListener('click',function(e){
    var t=e.target; if(!t||t.nodeType!==1) return;
    if(t.closest('[data-vcod-open]')){ e.preventDefault(); open(); return; }
    if(!overlay) return;
    if(t.closest('.vcod-x')||t.closest('[data-act="close"]')){ close(); return; }
    if(t===overlay){ close(); return; }
    var q=t.closest('.vcod-q');
    if(q&&overlay.contains(q)){
      var n=qty+parseInt(q.getAttribute('data-q'),10);
      if(n<1)n=1; if(n>20)n=20;
      if(n!==qty){ qty=n; refreshSummary(); }
      return;
    }
    if(t.closest('[data-act="editauto"]')){ unlockAuto(); return; }
    if(t.closest('[data-act="cod"]')){ submitCOD(); return; }
    if(t.closest('[data-act="prepaid"]')){ submitPrepaid(); return; }
  });

  document.addEventListener('input',function(e){
    var t=e.target; if(!t||!t.id||t.id.indexOf('vcod-')!==0) return;
    if(t.id==='vcod-phone'||t.id==='vcod-zip') t.value=t.value.replace(/\D/g,'');
    if(t.value) clearErr(t);
    if(t.id==='vcod-zip' && t.value.length===6) lookupPin(t.value);
  });
  document.addEventListener('change',function(e){
    var t=e.target;
    if(t&&t.id==='vcod-province'){ checkedPin=''; checkCod(); return; }
    if(!t||!t.form||!t.form.action||t.form.action.indexOf('/cart/add')===-1) return;
    setTimeout(function(){
      variantId=readVariant();
      if(overlay&&overlay.classList.contains('vcod-on')) refreshSummary();
    },60);
  });
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'&&overlay&&overlay.classList.contains('vcod-on')) close();
  });

  function boot(){
    injectButton();
    new MutationObserver(function(){ injectButton(); })
      .observe(document.body,{childList:true,subtree:true});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();

  window.VCOD={open:open, close:close, url:checkoutUrl};
})();
